export type Viewport = 'mobile' | 'tablet' | 'desktop';

export enum DsBuilderMethod {
  CATEGORY_PAGE = 0,
  TEMPLATE_SELECTION = 1,
  STORE_NAME = 2,
  SITE_PREVIEW = 3,
  CHECKOUT = 4,
}
